module.exports = __webpack_public_path__ + "static/media/avatarnew.ebbd08bc.svg";